module.exports = __webpack_public_path__ + "img/wtyc9.c9466d84.png";